<div class="navigationbar-container" [ngClass]="rootClassName">
  @if (!isClose && isWeb) {
    <div class="breadcrumbs-container">
      <div class="breadcrumbs">
        @if (rootSegment) {
          <span class="breadcrumbs-item" (click)="onSelect(rootSegment)">{{rootSegment.title.toString() | titlecase}}</span>
        } @else {
          <div class="frame24pxspacer"></div>
        }
        @for (segment of segments; track $index; let idx=$index) {
          @if (segment.title && segment.path) {
            <span>&nbsp;{{'/'}}&nbsp;</span>
            <span class="breadcrumbs-item" [ngClass]="{'disabled': checkDisabled(segment)}" (click)="onSelect(segment, idx)">{{segment.title.toString() | titlecase}}</span>
          }
        }
      </div>
    </div>
  }
  <div class="title-container">
    @for (tab of tabs; track $index; let isFirst = $first, isLast = $last) {
      @if (tab.title || tab.icon) {
        <div class="title-col" [ngClass]="tab.name" (click)="onAction(tab.name)">
          @if (isLast && tab.title) { <span class="title-text spacer-right headingboldmedium">{{tab.title}}</span> }
          <span [@collapseHorizontally]="isFirst && !tab.icon" class="title-icon-container" [ngStyle]="iconStyle(isLast)">
            @if (tab.icon) { <img [@fadeInOnEnter] class="title-icon" id="{{tab.icon.id}}" alt="{{tab.icon.alt}}" width="24" height="24" [ngSrc]="tab.icon.src"/> }
          </span>
          @if (isFirst && tab.title) { <span class="title-text spacer-left headingboldmedium" [ngClass]="{'dark':isDark}">{{tab.title}}</span> }
        </div>
      }
    }
  </div>
</div>
